import styles from '../styles.module.css';
import React, { useEffect, useState } from 'react';

import { components, default as ReactSelect } from 'react-select';
import selectStyles from '../../../components/Select/Select.module.css';

const CustomMenu = (props: any) => {
    const { placement, innerRef, innerProps, isDisabled, children } = props;
    return !isDisabled ? (
        <div
            ref={innerRef}
            {...innerProps}
            className={`${selectStyles.dropdownMenu} ${styles.selectMenu} ${
                placement === 'top' ? selectStyles.dropdownTop : selectStyles.dropdownBottom
            } ${placement === 'top' ? styles.selectMenuTop : styles.selectMenuBottom}`}
        >
            {children}
        </div>
    ) : null;
};

const CustomChevron = ({ innerRef, ...innerProps }: any) => {
    return (
        <components.DropdownIndicator {...innerProps}>
            <svg
                ref={innerRef}
                xmlns="http://www.w3.org/2000/svg"
                width="19.931"
                height="10.673"
                viewBox="0 0 19.931 10.673"
                style={{
                    transform: innerProps.selectProps.menuIsOpen ? 'rotate(-180deg)' : '',
                }}
            >
                <path
                    id="Path_1174"
                    data-name="Path 1174"
                    d="M5271.342,2230l9.612,9.612,9.612-9.612"
                    transform="translate(-5270.988 -2229.646)"
                    fill="none"
                    stroke="currentcolor"
                    strokeWidth="1"
                />
            </svg>
        </components.DropdownIndicator>
    );
};

interface ContactFormInputProps {
    className?: string;
    isTextarea?: boolean;
    isSelect?: boolean;
    options?: { value: string; label: string }[];
    label: string;
    type?: string;
    onChange?: any;
    value?: string;
    selectValue?: any;
    disabled?: boolean;
    readOnly?: boolean;
    required?: boolean;
}

const ContactFormInput = ({
    className,
    isTextarea,
    isSelect,
    options,
    label,
    type,
    onChange,
    value,
    selectValue,
    disabled,
    readOnly,
    required,
}: ContactFormInputProps) => {
    const [active, setActive] = useState(false);
    const [menuPlacement, setMenuPlacement] = useState<string>('bottom');

    useEffect(() => {
        if (value || selectValue) {
            setActive(true);
        }
    }, [value, selectValue]);

    const handleFocus = () => {
        setActive(true);
    };

    const handleBlur = () => {
        if (!value && !selectValue) {
            setActive(false);
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (onChange) {
            onChange(e);
        }
    };

    const handleSelectChange = (selectedOption: any) => {
        if (onChange) {
            onChange(selectedOption);
        }
    };

    return (
        <label className={`${styles.label} ${active ? styles.focused : ''} ${className || ''}`}>
            <span className={styles.placeholder}>
                {label}
                {required && ': *'}
            </span>
            {isSelect ? (
                /* @ts-ignore */
                <ReactSelect
                    options={options}
                    value={options?.find((o) => o.label === selectValue || o.value === selectValue)}
                    onChange={handleSelectChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    placeholder=""
                    isSearchable={true}
                    isDisabled={disabled}
                    components={{
                        Menu: CustomMenu,
                        DropdownIndicator: CustomChevron,
                        IndicatorSeparator: () => null,
                    }}
                    unstyled={true}
                    minMenuHeight={160}
                    maxMenuHeight={200}
                    // @ts-expect-error: custom types needed
                    onPlacementChange={setMenuPlacement}
                    classNames={{
                        control: (state) =>
                            `${styles.selectControl} ${state.isFocused ? styles.selectControlFocused : ''} ${
                                state.menuIsOpen
                                    ? menuPlacement === 'top'
                                        ? styles.controlTop
                                        : styles.controlBottom
                                    : ''
                            }`,
                        valueContainer: () => styles.selectValueContainer,
                        placeholder: () => styles.selectPlaceholder,
                        singleValue: () => styles.selectSingleValue,
                        input: () => styles.selectInput,
                        menuList: () => styles.selectMenuList,
                        option: (state) =>
                            `${styles.selectOption} ${state.isSelected ? styles.selectOptionSelected : ''} ${
                                state.isFocused ? styles.selectOptionFocused : ''
                            }`,
                    }}
                    styles={{
                        menuList: (provided) => ({
                            ...provided,
                            maxHeight: '150px', // Set max height for the options list
                            minHeight: '50px', // Optional: set a minimum height
                        }),
                    }}
                />
            ) : isTextarea ? (
                <textarea
                    className={styles.input}
                    value={value ?? ''}
                    disabled={disabled}
                    readOnly={readOnly}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    onChange={handleChange}
                />
            ) : (
                <input
                    type={type || 'text'}
                    value={value ?? ''}
                    className={styles.input}
                    disabled={disabled}
                    readOnly={readOnly}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    onChange={handleChange}
                />
            )}
        </label>
    );
};

export default ContactFormInput;
